import { UiButton, UiSelect } from "@/components/ui";
import { Edit } from "lucide-react";
import {
  StatCardItem,
  StatsCard,
  WhiteCard,
  DashboardHeader,
} from "@/components";
import { Head } from "@/components/seo";

const Dashboard = () => {
  const cities = ["Abidjan", "Dakar", "Bamako", "Conakry", "N'Djamena"].map(
    (city) => ({ value: city, label: city })
  );
  return (
    <>
      <Head
        title="Tableau de bord | Jourgui"
        description="Bienvenue à la plateforme Jourgui"
      ></Head>
      <DashboardHeader
        subTitle="Bienvenue à la plateforme Jourgui"
        selectSlot={<UiSelect options={cities} defaultValue="Dakar" />}
      />

      <div>
        <StatsCard>
          <StatCardItem
            title="Naissances"
            value="89935"
            evolution="+1.01% this week"
          />
          <StatCardItem
            title="Déclarations"
            value="23283.5"
            evolution="+1.01% this week"
          />
          <StatCardItem
            title="Animaux vaccinés"
            value="46827"
            direction="down"
            evolution="-0.09% this week"
          />
          <StatCardItem
            title="vols de bétails"
            value="23283.5"
            evolution="+1.01% this week"
          />
          <StatCardItem
            title="foyers épidémiques"
            value="124"
            evolution="+1.01% this week"
          />
          <StatCardItem
            title="bêtes identifiées"
            value="124854"
            evolution="+1.01% this week"
          />
          <StatCardItem
            title="budget dépensé"
            value="1926336562"
            evolution="+1.01% this week"
          />
        </StatsCard>
      </div>

      <div className="py-4">
        <WhiteCard>
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-primary">Campagne_1</h1>
            </div>
            <div>
              <UiButton>
                <Edit />
              </UiButton>
            </div>
          </div>
        </WhiteCard>
      </div>

      <div className="py-4">
        <WhiteCard>
          <div className="flex items-center gap-2">
            <UiButton className="uppercase" color="primary">
              Graphique
            </UiButton>
            <UiButton className="uppercase" color="secondary">
              Tableau
            </UiButton>
          </div>

          <div></div>
        </WhiteCard>
      </div>
    </>
  );
};

export default Dashboard;
